{
    "SectionheaderReportoptions": "Opções de relatório",
    "ReporttablabelStyle": "Estilo:",
    "ReporttablabelName": "Nome:",
    "ReporttablabelFolder": "Pasta:",
    "ReporttablabelNote": "Nota:",
    "ReporttabReportnameoverwritePromptTextFormatString": "alterou o estilo de relatório deste relatório - Deseja substituir automaticamente o nome existente do relatório por '|1'?",
    "NAME": "ReportOptions",
    "ReporttablabelInterval": "Intervalo:",
    "ReporttablabelEntity": "Entidade:"
}